import type { AppState } from "@/app/state/types";

export function buildConversationResetState(
	state: AppState,
	options: { preserveWorkerContext?: boolean } = {},
): AppState {
	const preserveWorkerContext = Boolean(options.preserveWorkerContext);
	return {
		...state,
		currentChatActiveRun: null,
		runId: "",
		currentRunAgentKey: "",
		pendingNewChatAgentKey: "",
		requestId: "",
		streaming: false,
		abortController: null,
		messagesById: new Map(),
		messageOrder: [],
		events: [],
		debugEvents: [],
		artifacts: [],
		fileChanges: [],
		plan: null,
		planRuntimeByTaskId: new Map(),
		taskItemsById: new Map(),
		activeTaskIds: new Set(),
		planCurrentRunningTaskId: "",
		planLastTouchedTaskId: "",
		artifactExpanded: false,
		artifactManualOverride: null,
		artifactAutoCollapseTimer: null,
		planExpanded: false,
		planManualOverride: null,
		planAutoCollapseTimer: null,
		toolStates: new Map(),
		toolNodeById: new Map(),
		contentNodeById: new Map(),
		pendingTools: new Map(),
		reasoningNodeById: new Map(),
		reasoningCollapseTimers: new Map(),
		actionStates: new Map(),
		executedActionIds: new Set(),
		timelineNodes: new Map(),
		timelineOrder: [],
		timelineNodeByMessageId: new Map(),
		timelineDomCache: new Map(),
		timelineCounter: 0,
		renderQueue: {
			dirtyNodeIds: new Set(),
			scheduled: false,
			stickToBottomRequested: false,
			fullSyncNeeded: false,
		},
		activeReasoningKey: "",
		activeFrontendTool: null,
		activeAwaiting: null,
		pendingAwaitings: [],
		usageSnapshot: null,
		usagePopoverOpen: false,
		rightSidebarOpenTab: null,
		activeSourceDetail: null,
		planningPreviews: [],
		attachmentPreview: [],
		inputMode: "text",
		voiceChat: {
			...state.voiceChat,
			status: "idle",
			sessionActive: false,
			partialUserText: "",
			partialAssistantText: "",
			activeAssistantContentId: "",
			activeRequestId: "",
			activeTtsTaskId: "",
			ttsCommitted: false,
			error: "",
			wsStatus: "idle",
			currentAgentKey: "",
			currentAgentName: "",
		},
		workerRelatedChats: preserveWorkerContext ? state.workerRelatedChats : [],
		workerChatPanelCollapsed: preserveWorkerContext
			? state.workerChatPanelCollapsed
			: true,
		pendingSteers: state.pendingSteers,
		downvotedRunKeys: new Set(),
		eventPopoverIndex: -1,
		eventPopoverEventRef: null,
		eventPopoverAnchor: null,
		commandStatusOverlay: {
			visible: false,
			commandType: null,
			phase: "success",
			text: "",
			timer: null,
		},
	};
}
